import { image } from "../../resource";
import color from "../../resource/color";

export type CompanyCode = "ICPF" | "ICPI" | "ICPL";

export interface TierDefinition {
  key: string;
  label: string;
  subLabel: string;
  color: string;
  img?: string;
}

export interface ShopTierCompanyConfig {
  company: CompanyCode;
  companyLabel: string;
  volumeUnit: string;
  percentLabel: string;
  tiers: TierDefinition[];
}

const DEFAULT_COMPANY: CompanyCode = "ICPF";

export const SHOP_TIER_CONFIG: Record<CompanyCode, ShopTierCompanyConfig> = {
  ICPF: {
    company: "ICPF",
    companyLabel: "ICP Fertilizer",
    volumeUnit: "ตัน (MT)",
    percentLabel: "Top Up",
    tiers: [
      { key: "Follow", label: "Follow", subLabel: "0-999 ตัน (MT)", color: color.Grey, img: image.follow },
      { key: "Focus", label: "Focus", subLabel: "1,000-3,499 ตัน (MT)", color: color.secondary2, img: image.focus },
      { key: "First", label: "First", subLabel: "3,500-5,999 ตัน (MT)", color: color.primary, img: image.first },
      { key: "First+", label: "First+", subLabel: "6,000-9,999 ตัน (MT)", color: color.secondary, img: image.firstPlus },
      { key: "Finale", label: "Finale", subLabel: "ตั้งแต่ 10,000 ตัน (MT)", color: color.gold, img: image.finale },
    ],
  },
  ICPI: {
    company: "ICPI",
    companyLabel: "ICP International",
    volumeUnit: "ตัน (MT)",
    percentLabel: "Top Up",
    tiers: [
      { key: "Follow", label: "Follow", subLabel: "0-999 ตัน (MT)", color: color.Grey, img: image.follow },
      { key: "Star", label: "Star", subLabel: "1,000-1,499 ตัน (MT)", color: color.secondary2, img: image.star },
      { key: "Strategic", label: "Strategic", subLabel: "1,500-2,999 ตัน (MT)", color: color.primary, img: image.strategic },
      { key: "Wisdom", label: "Wisdom", subLabel: "3,000-4,999 ตัน (MT)", color: color.secondary, img: image.wisdom },
      { key: "Wisdom Plus", label: "Wisdom Plus", subLabel: "5,000-9,999 ตัน (MT)", color: color.purple, img: image.wisdomPlus },
      { key: "Wisdom Prime", label: "Wisdom Prime", subLabel: "ตั้งแต่ 10,000 ตัน (MT)", color: color.gold, img: image.wisdomPrime },
    ],
  },
  ICPL: {
    company: "ICPL",
    companyLabel: "ICP Ladda",
    volumeUnit: "ล้านบาท",
    percentLabel: "Top Up",
    tiers: [
      { key: "Basic", label: "Basic", subLabel: "0-5 ล้านบาท", color: color.Grey, img: image.basic },
      { key: "Potential Star", label: "Potential Star", subLabel: "5-9 ล้านบาท", color: color.secondary2, img: image.potentialStar },
      { key: "Power Focus", label: "Power Focus", subLabel: "10-19 ล้านบาท", color: color.primary, img: image.powerFocus },
      { key: "Prestige", label: "Prestige", subLabel: "20-29 ล้านบาท", color: color.secondary, img: image.prestige },
      { key: "Prestige Plus", label: "Prestige Plus", subLabel: "30-49 ล้านบาท", color: color.purple, img: image.prestigePlus },
      { key: "Partner", label: "Partner", subLabel: "50 ล้านบาทขึ้นไป", color: color.gold, img: image.partner },
    ],
  },
};

export function resolveShopTierConfig(company?: string | null): ShopTierCompanyConfig {
  if (company === "ICPF" || company === "ICPI" || company === "ICPL") {
    return SHOP_TIER_CONFIG[company];
  }
  return SHOP_TIER_CONFIG[DEFAULT_COMPANY];
}
